export default __webpack_public_path__ + "static/media/donate-button.16757baf.png";